// extracted by mini-css-extract-plugin
export var header = "_v8-1";
export var maskBottom = "_v8-6";
export var maskMiddle = "_v8-7";
export var maskTop = "_v8-5";
export var root = "_v8-0";
export var scrollDownButton = "_v8-3";
export var scrollDownButtonHidden = "_v8-4";
export var viewport = "_v8-2";